import React from 'react';
import { styled, Typography } from '@mui/material';
import { getStyleByStatus } from '../../../components/Chip/utils';
import { ChipStatus } from '../../../components/Chip';

const CircledNumber: React.FC<{ value: string; status?: ChipStatus }> = ({ value, status }) => {
  return (
    <CustomCircle variant="body2" data-testid="circled-number" status={status}>
      {value}
    </CustomCircle>
  );
};

export default CircledNumber;

const CustomCircle = styled(Typography)<{ status?: ChipStatus }>(({ theme, status }) => ({
  ...(!status ? { backgroundColor: theme.palette.primary.main, color: 'white' } : getStyleByStatus(status, theme)),
  padding: theme.spacing(1),
  fontSize: 12,
  lineHeight: '12px',
  fontWeight: '600',
  borderRadius: 20,
  marginLeft: theme.spacing(1),
  height: 10,
  minWidth: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
